module.exports = __webpack_public_path__ + "media/images/mail/head-image-b1c03e124475c292d13e0f83fe719873.png";